var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row p6 radius6 animate-bottom"
  }, [_c('div', {
    staticClass: "form-container"
  }, [_c('header', {
    staticClass: "row p12",
    staticStyle: {
      "background": "#f2f2f2"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "h-filter"
  }, [_vm.checkoutPermission('CREATE_CURRENCY') ? _c('router-link', {
    attrs: {
      "to": {
        name: 'CreateCurrency'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm"
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New ")])]) : _vm._e()], 1)]), _c('div', {
    staticClass: "table-control"
  }, [_c('table', {
    staticClass: "table wh800",
    attrs: {
      "cellspacing": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "w70 txt-center"
  }, [_vm._v("No")]), _c('th', {
    attrs: {
      "width": "200px"
    }
  }, [_vm._v("Name")]), _c('th', [_vm._v("Code")]), _vm.checkoutPermission('UPDATE_CURRENCY') || _vm.checkoutPermission('DELETE_CURRENCY') ? _c('th', {
    staticStyle: {
      "text-align": "center",
      "width": "100px"
    }
  }, [_vm._v(" Action ")]) : _vm._e()])]), _vm.checkoutPermission('LIST_CURRENCY') ? _c('tbody', _vm._l(_vm.data.currencies, function (currency, index) {
    return _c('tr', {
      key: (currency, index),
      staticClass: "hover-list"
    }, [_c('td', {
      staticClass: "txt-center"
    }, [_vm._v(_vm._s(index + 1))]), _c('td', [_vm._v(_vm._s(currency.name))]), _c('td', {
      staticClass: "center"
    }, [_vm._v(_vm._s(currency.code))]), _c('td', {
      staticClass: "txt-center"
    }, [_vm.checkoutPermission('UPDATE_CURRENCY') ? _c('router-link', {
      attrs: {
        "to": {
          name: 'EditCurrency',
          query: {
            code: currency.code
          }
        }
      }
    }, [_c('button', {
      staticClass: "btn btn-info btn-xs mr5"
    }, [_c('i', {
      staticClass: "fa fa-pen"
    })])]) : _vm._e(), _vm.checkoutPermission('DELETE_CURRENCY') ? _c('button', {
      staticClass: "btn btn-danger btn-xs",
      on: {
        "click": function ($event) {
          return _vm.popupModalDelete(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()], 1)]);
  }), 0) : _vm._e()]), _vm.isFetching ? _c('TableLoading') : _vm._e(), _vm.isNoData ? _c('NoItem') : _vm._e()], 1), _c('div', {
    staticClass: "total ph12"
  }, [_c('div', {
    staticClass: "ul-xl-li"
  }, [_vm._v("Total : " + _vm._s(_vm.data.currencies.length))])])])]), _vm.display.modal.delete.show ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": _vm.closeModal
    }
  }), _c('div', {
    staticClass: "modal-md"
  }, [_vm._m(1), _vm._m(2), _c('div', {
    staticClass: "modal-footer border-top"
  }, [!_vm.isDeleting ? _c('button', {
    staticClass: "btn btn-info btn-xs go-right",
    on: {
      "click": _vm.deleteCurrency
    }
  }, [_vm._v(" Yes ")]) : _c('button', {
    staticClass: "btn btn-info btn-xs go-right"
  }, [_vm._v("Loading...")]), !_vm.isDeleting ? _c('button', {
    staticClass: "btn btn-light-secondary btn-xs mr12 go-right",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" No ")]) : _c('button', {
    staticClass: "btn btn-light-secondary btn-xs mr12 go-right"
  }, [_vm._v(" No ")])])])]) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "go-left",
    staticStyle: {
      "display": "inline-block",
      "position": "relative"
    }
  }, [_c('b', [_vm._v("Currency")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "modal-header border-bottom txt-info"
  }, [_c('span', {
    staticClass: "txt-sm"
  }, [_vm._v("Delete")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow-y": "hidden",
      "padding": "16px"
    }
  }, [_c('span', [_vm._v("Do you want to delete this record?")])]);

}]

export { render, staticRenderFns }